import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ProgramTemplate } from '@libs/src/models/program-template.model';

const v2GroupsAPI = (groupId: string) => `/api/v2/groups/${groupId}`;

const getV2Url = (groupId: string) =>
  `${v2GroupsAPI(groupId)}/program-templates`;

@Injectable({ providedIn: 'root' })
export class ProgramTemplatesBackend {
  constructor(private http: HttpClient) {}
  v2 = {
    createProgramTemplate: (groupId: string, programTemplate: any) => {
      return this.http.post(getV2Url(groupId), { programTemplate });
    },
    getProgramTemplate: (groupId: string, programTemplateId: string) => {
      return this.http.get(`${getV2Url(groupId)}/${programTemplateId}`);
    },
    listProgramTemplates: (
      groupId: string,
      params: { limit: string; skip: string } = { limit: '50', skip: '0' },
    ) => {
      return this.http.get(getV2Url(groupId), { params });
    },
    patchProgramTemplate: (
      groupId: string,
      templateId: string,
      programTemplate: ProgramTemplate,
    ) => {
      return this.http.patch(`${getV2Url(groupId)}/${templateId}`, {
        programTemplate,
      });
    },
  };
}
